<template>
    <div>
        <div class="box_top">
            <div class="el-icon-s-home">当前位置：</div>
            <el-breadcrumb separator=">>">
                <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{top_title}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{peak_title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="box_footer">
            <div class="box_footer_left">
                <div class="box_footer_left_title">{{top_title}}</div>
                <div class="box_footer_left_li_box">
                    <div class="box_footer_left_li" v-for="(item,index) in boxlist" :key="item.id" @mouseover="over(index)" @mouseout="out" @click="hit(item,index)">
                        <div :class="{box_active:index==overNumber}">{{item.name}}</div>
                    </div>
                </div>
            </div>
            <div class="box_footer_right">
              <div class="box_footer_right_top">{{peak_title}}</div>
              <div class="box_footer_right_footer">
                <slot></slot>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        boxlist:{
            type:Array
        },
        top_title:{
            type:String
        },
        overNumber:{
            type:Number,
            default:1
        },
        peak_title:{
            type:String
        }
    },
    data(){
        return {
            // overNumber1:1,
            // title1:'',
            // 点击的是哪一个标题的索引
            outi:null
        }
    },
    created(){
        // this.overNumber1=this.overNumber
    },
    methods:{
        over(i){
            // this.overNumber1=i
            this.$emit('changeOvernumberBtn',i)
        },
        out(){
            if(this.outi){
                this.$emit('changeOvernumberBtn',this.outi)
            }else{
                this.$emit('changeOvernumberBtn',Number(this.$route.query.overNumber))
            }
        },
        hit(item,i){
            // this.overNumber1=i
            this.$emit('changeOvernumberBtn',i)
            this.outi=i
            this.$emit('changeTitleBtn',item.name)
            // this.title1=item.name
            // 这里拿到索引与值，触发父级函数，将索引与值传给父级
            this.$emit('hitTo',item)
            if(item.type!==2){
                this.$router.push({path:'/tissue',query:{pid:item.pid,id:item.id,overNumber:i}})
            }
        }
    }
}
</script>

<style lang="less" scoped>
.box_top{
    height: 46px;
    border-bottom: 1px solid #edebea;
    margin-top: 15px;
    line-height: 46px;
    display: flex;
    align-items: center;
    div{
        font-size: 14px;
        color: #666;
    }
    .el-breadcrumb{
        margin-left: 10px;
        font-size: 14px;
        color: #666;
    }
}
.box_footer{
    margin: 30px 0;

    .box_footer_left{
        float: left;
        width: 255px;
        .box_footer_left_title{
            height: 80px;
            background-color: #da2b2b;
            font-size: 24px;
            font-weight: bold;
            color: #fff;
            text-align: center;
            line-height: 80px;
        }

        .box_footer_left_li_box{
            background-color: #fff0e5;
            color: #333333;
            font-size: 16px;
            .box_footer_left_li{
                // height: 26px;
                width: calc(100% - 6px);
                padding: 15px 3px;
                border-top: 1px solid #fff;
                line-height: 20px;
                text-align: center;
                cursor: pointer;
            }
        }
    }

    .box_footer_right{
        float: left;
        // background-color: red;
        margin-left: 40px;
        width: 905px;
        min-height: 550px;

        .box_footer_right_top{
            height: 78px;
            line-height: 78px;
            color: #cc0000;
            font-size: 24px;
            border-bottom: 2px solid #cc0000;
            font-weight: bold;
        }
        .box_footer_right_footer{
            font-size: 16px;
            margin-top: 15px;
            color: #333333;
        }
    }
}
.box_footer_left::after{
        content: '';
        height: 0;
        visibility: hidden;
        display: block;
        clear: both;
    }

.box_active{
    border-left: 5px solid #da2b2b;
    box-sizing: border-box;
}
</style>